import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Section = styled.section`
  display: flex;
  justify-content: space-around;
  padding: 1rem 0rem 1rem;
  max-width: 1250px;
  flex: 1;
  flex-direction: column;
`

export const ButtonSection = styled.section`
  display: flex;
  justify-content: space-between;
  padding: 0rem 0rem 1rem;
  max-width: 1250px;
  max-height: 50px;
  flex: 1;
  gap: 8px;
  margin-bottom: 1.2rem;
`

export const WrapperSection = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0;
  max-width: 1250px;
`

export const Label = styled.label`
  display: flex;
  font-size: 1.2rem;
  font-weight: bold;
  flex: 1;
  padding: 0 1rem;
`

export const Text = styled.p`
  line-height: inherit;
  font-size: inherit;
  font-weight: normal;
`

export const BackButton = styled(ButtonMui)`
  width: 6rem;
  height: 2.5rem;
`

export const ActionButton = styled(ButtonMui)`
  width: 23rem;
  height: 2.5rem;
`

export const CustomText = styled.p`
  font-size: 0.8rem;
  color: #000;
  width: 60rem;
  height: 2rem;
  padding-left: 1rem;
`
